module.exports = __webpack_public_path__ + "img/107.13df606e.jpg";